import { CoverageLevelValue } from "../../../types";

export const resetSelectedCoverageLevels = (coverageLevels: CoverageLevelValue[]): CoverageLevelValue[] => {
	return coverageLevels.map((coverageLevel: CoverageLevelValue)=>{

		return {...coverageLevel, isSelected: false}
	})
}
